module.exports = __webpack_public_path__ + "static/media/1.d3515f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16007/1.jpg
// module id = 500
// module chunks = 0